<div class="backoffice-breadcrumb" [style.background-color]="catalogueService.getProperty('mainColor')" >
  <svg width="24" height="24" (click)="backToProducts()"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.7051 7.41L11.1251 12L15.7051 16.59L14.2951 18L8.29508 12L14.2951 6L15.7051 7.41Z" fill="#fff" />
  </svg>
  <span (click)="backToProducts()" >{{ 'COMMON.BACK_TO_PRODUCTS' | translate }}</span>
</div>

<div class="row pd-t50 exhibitor-backoffice-sub-header" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">
  <div class="col-lg-10 title-container">
    <h1 *ngIf="utilsService._api(product['translations'], 'name') && utilsService._api(product['translations'], 'name').length > 55">{{ utilsService._api(product['translations'], 'name').substring(0, 55) }}...</h1>
    <h1 *ngIf="utilsService._api(product['translations'], 'name') && utilsService._api(product['translations'], 'name').length <= 55">{{ utilsService._api(product['translations'], 'name') }}</h1>
  </div>
  <div class="col-lg-2" *ngIf="buttonTranslation">
     <button type="button" (click)="goTo(buttonLink)" class="btn btn-light float-end mr-sm-2 mb-2">{{ buttonTranslation | translate }}</button>
  </div>
  <div class="col-12">
    <ul class="nav">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ 'active': active === 'detail' }" routerLink="/{{ catalogueName }}/exhibitor-backoffice/exhibitors/{{exhibitorId}}/exhibitor-detail">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITORS.DETAIL' | translate }}</a>
      </li>
    </ul>
  </div>
</div>
